import { hybridEncrypt, encryptPayload } from "./backendEncryption";
import { hybridDecrypt, decryptBackendResponse, isEncryptedResponse } from "./backendDecryption";

export function getProxyEndpoint(endpoint) {
  if (!endpoint) return '/api/proxy';
  
  // Normalize endpoint URL (remove leading slash if present for comparison)
  const normalizedUrl = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  
  // Check if the endpoint starts with auth/v1, admin/v1, or exam/v1 (or exams/v1)
  if (normalizedUrl.startsWith('auth/v1/')) {
    return 'auth/v1/api/proxy';
  } else if (normalizedUrl.startsWith('admin/v1/')) {
    return 'admin/v1/api/proxy';
  } else if (normalizedUrl.startsWith('exam/v1/') || normalizedUrl.startsWith('exams/v1/')) {
    return 'exams/v1/api/proxy';
  }
  
  // Default proxy endpoint
  return '/api/proxy';
}

export async function encryptRoutingInfo(routingInfo) {
  try {
    const endpointWithSlash = routingInfo.endpoint.startsWith('/') 
      ? routingInfo.endpoint 
      : `/${routingInfo.endpoint}`;
    
    // Log the decrypted payload before encryption
    // console.log('🔓 API Request (Decrypted Form):', {
    //   endpoint: endpointWithSlash,
    //   method: routingInfo.method || 'GET',
    //   body: routingInfo.body,
    //   params: routingInfo.params
    // });
    
    let encryptedBody = routingInfo.body;
    if (routingInfo.body && !(routingInfo.body instanceof FormData)) {
      encryptedBody = await encryptPayload(routingInfo.body);
    }
    
    const finalRoutingInfo = {
      endpoint: endpointWithSlash,
      method: routingInfo.method || 'GET',
      body: encryptedBody,
      params: routingInfo.params
    };
    
    const encryptedRoute = await hybridEncrypt(finalRoutingInfo);
    
    // Log encrypted form for comparison
    const normalizedEndpoint = routingInfo.endpoint.startsWith('/') 
      ? routingInfo.endpoint.substring(1)
      : routingInfo.endpoint;
    const proxyEndpoint = getProxyEndpoint(normalizedEndpoint);
    
    // console.log('🔒 API Request (Encrypted Form):', {
    //   proxyEndpoint: proxyEndpoint,
    //   envelope: encryptedRoute.envelope.substring(0, 50) + '...',
    //   signature: encryptedRoute.signature.substring(0, 20) + '...'
    // });
    
    return encryptedRoute;
  } catch (error) {
    console.error("Error encrypting routing info:", error);
    throw error;
  }
}


export async function decryptResponseData(data) {
  if (!data) return data;
  
  try {
    if (isEncryptedResponse(data)) {
      return await decryptBackendResponse(data);
    }
    
    if (typeof data === 'object' && data !== null) {
      if (data.envelope && data.signature) {
        return await hybridDecrypt({
          envelope: data.envelope,
          signature: data.signature
        });
      }
      
      if (data.data && typeof data.data === 'object' && data.data.envelope && data.data.signature) {
        const decrypted = await hybridDecrypt({
          envelope: data.data.envelope,
          signature: data.data.signature
        });
        return { ...data, data: decrypted };
      }
    }
    
    // If not encrypted, return as is
    return data;
  } catch (error) {
    console.error("Error decrypting response:", error);
    // Don't return original - throw error so caller knows decryption failed
    throw new Error(`Failed to decrypt response: ${error.message}`);
  }
}

